require('./sctAvatar.scss');

const randomColor = require('randomcolor');

const sctAvatar = angular.module('app.sct.avatar', []);

sctAvatar.component('sctAvatar', {
  bindings: {
    profile: '='
  },
  controller: ['$scope', controller],
  controllerAs: 'vm',
  template: require('./sctAvatar.html')
});

function controller($scope) {
  let vm = this;
  vm.color = undefined;
  vm.texColor = undefined;
  vm.initials = undefined;

  vm.profileName = profileName;

  $scope.$watch('vm.profile', profileUpdated, true);

  function profileUpdated(profile) {
    vm.initials = profileInitials(profile);

    vm.color = randomColor({
      seed: vm.initials,
      luminosity: 'light'
    });

    if(vm.initials.length === 1) {
      vm.color = '#d5d8dc';
    }

    const colorBrightness = getBrightness(vm.color);
    vm.texColor = colorBrightness > 220 ? 'rgba(38,32,50,0.95)' : 'rgba(255,255,255,0.95)';
  }

  function profileName(profile) {
    if(!profile) {
      return '';
    }

    if (profile.Firstname && profile.Lastname) {
      return `${profile.Firstname} ${profile.Lastname}`;
    }

    if(profile.Email) {
      return profile.Email;
    }

    return '';
  }

  function profileInitials(profile) {
    if(!profile) {
      return '';
    }
    
    if (!profile.Firstname || !profile.Firstname) {
      if(profile.Email) {
        return profile.Email.slice(0, 1).toUpperCase();
      } else {
        return '';
      }
    } else {
      const initials = `${profile.Firstname} ${profile.Lastname}`.match(/\b\w/g) || [];
      return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    }
  }

  function getBrightness(hexCode) {
    const hexValue = hexCode.replace('#', '');
    const c_r = parseInt(hexValue.substr(0, 2),16);
    const c_g = parseInt(hexValue.substr(2, 2),16);
    const c_b = parseInt(hexValue.substr(4, 2),16);

    return parseInt(((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000);
  }
}

export default sctAvatar;



// WEBPACK FOOTER //
// ./src/components/sct/sctAvatar/sctAvatar.js